import { ReactElement } from 'react';
import ContactInformation from '@components/ContactInformation/ContactInformation';
import { extensionContactInfoDisplayObject } from '@services/FormFieldConfig';

function ExtensionStep6(): ReactElement {
  return (
    <>
      <ContactInformation displayObject={extensionContactInfoDisplayObject} currentStep="Select if you do not have an email address" />
    </>
  );
}
export default ExtensionStep6;
